import React from 'react';
import classNames from 'classnames';

export default class InputText extends React.PureComponent {
    constructor(props) {
        super(props);
        this.inputRef = props.inputRef;
    }

    render() {
        const { className, inputRef, ...rest } = this.props;
        const inputClasses = classNames('input-text', this.props.disabled && 'disabled', className);

        return <input type='text' ref={inputRef} className={inputClasses} {...rest} />;
    }
}



// WEBPACK FOOTER //
// ./components/InputText/InputText.jsx